module.exports = __webpack_public_path__ + "static/media/workshops.cb4a095e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/workshops.jpg
// module id = 506
// module chunks = 0